import { Location } from '@angular/common';
import {
  Component,
  EventEmitter,
  HostListener,
  OnInit,
  Output,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
// import { DataService } from '../../services/data.service';
// import { PosPage } from '../../pages/pos/pos.page';
// import { Storage } from '@ionic/storage';
import { Storage } from '@ionic/storage-angular';
import { Platform } from '@ionic/angular';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.scss'],
})
export class CategoriesComponent  implements OnInit {
  category_child;
  mobile_child;
  skeleton;
  ismobile;
  active = -1;
  show_hide:any = true;
  show_category:any = false;
  sub_cate_list:any=[];
  @Output() filter = new EventEmitter();
  constructor(private platform: Platform,public storage: Storage, private route: ActivatedRoute, public db: DataService, private router: Router, private location: Location) {
  }

  ngOnInit() {
    this.ismobile = this.db.checkmobile();
    this.get_category();
    this.route.params.subscribe((res:any) => {
      if (res.product && !res.product_1 && !res.product_2) {
        this.db.choosed_product_id = this.route.snapshot.paramMap.get('product'); //for api call
      } else if (res.product && res.product_1 && !res.product_2) {
        this.db.choosed_product_id = this.route.snapshot.paramMap.get('product_1');
      } else if (res.product && res.product_1 && res.product_2) {
        this.db.choosed_product_id = this.route.snapshot.paramMap.get('product_2');
      }
      else {
        this.db.choosed_product_id = 'All';
        this.active = -1;
      }
    })
  }


  
  @HostListener('window:resize', ['$event'])
  private func(){
    this.db.ismobile  = this.db.checkmobile();
    this.ismobile  = this.db.checkmobile();
 
  }

  cat_count(id) {
    // let count = this.pos.all_products.filter(obj => obj.category == id);
    // let count = this.pos.all_products.filter((obj) => obj.category_mapping.some((category) => obj.category == id));
    // console.log(count)
    let count:any = [];
    // this.pos.all_products.map(res=>{
    //       res.category_mapping.map(value =>{
    //         if(value.category == id)
    //           // all_data = [...all_data,...res]
    //            count.push(res)
    //       })
    //     })
    return count.length
  }

  sub_count(id) {
    // let count = this.pos.all_products.filter((obj) => obj.category_mapping.some((category) => obj.category == id));
    return 0
  }

  get_category() {
    if (this.db.category.length == 0) {
      this.storage.get('category_list').then((val) => {
        if (!val || val.length == 0) {
          var data = {
            domain: this.db.domain,
            show_count:1,
            business:localStorage['business']
          }
          this.db.product_category(data).subscribe((data:any) => {
            this.db.category = data.message;
            this.storage.set('category_list', data.message)
            localStorage['__LastCategorySyncedDate'] = new Date();
            if (this.db.choosed_product_id != 'All') {
              let index = this.db.category.findIndex((x:any) => x.name === this.db.choosed_product_id);
              this.active = index;
            }
          }, error => { console.log(JSON.stringify(error.json())); });
        }
        else {
          this.db.category = val;
          if (this.db.choosed_product_id != 'All') {
            let index = this.db.category.findIndex((x:any) => x.name === this.db.choosed_product_id);
            this.active = index;
          }
        }
      });
    }
  }

  

  goto(route, child_no, index) {
    // console.log(route);
    // console.log(child_no);
    // console.log(index);
    if(child_no == 'child-1' || child_no == 'All')
      this.sub_cate_list = [];

    // this.pos.current_active = 'category';
    if (child_no == 'All') {
      this.location.replaceState("/inventory-management");
      this.active = index;
      this.db.choosed_product_id = 'All';
      this.filter.emit();
    }
    else {
      this.active = index;
      this.skeleton = true;
      setTimeout(() => { this.skeleton = false; }, 600);
      if ((child_no == 'child-1' && route.name != this.db.childs.child_1)) {
        this.db.childs.child_1 = route.name;
        this.db.childs.child_1_name = route.category_name;
        this.db.childs.child_2 = undefined
        this.db.childs.child_3 = undefined
        this.db.childs.child_2_name = undefined
        this.db.childs.child_3_name = undefined
        this.sub_cate_list = route.child;
        // this.location.replaceState("/pos/" + route.name);
        let check = document.getElementById(this.active + '_scroll') as HTMLInputElement
        check.scrollIntoView({ behavior: 'auto',block :'center' , inline :'center' })
      } else if ((child_no == 'child-2' && route.name != this.db.childs.child_2)) {
        this.db.childs.child_2 = route.name;
        this.db.childs.child_2_name = route.category_name;
        this.db.childs.child_3 = undefined
        this.db.childs.child_3_name = undefined;
        // this.location.replaceState("/pos/" + this.db.childs.child_1 + "/" + route.name);
        let check1 = document.getElementById(route.name + '_scroll') as HTMLInputElement
        check1.scrollIntoView({ behavior: 'auto',block :'center' , inline :'center' })
      } else if ((child_no == 'child-3' && route.name != this.db.childs.child_3)) {
        this.db.childs.child_3 = route.name;
        this.db.childs.child_3_name = route.category_name;
        // this.location.replaceState("/pos/" + this.db.childs.child_1 + "/" + this.db.childs.child_2 + "/" + route.name);
      }
      if (!this.ismobile && this.db.choosed_product_id != route.name) {
        this.db.choosed_brands = [];
        this.db.choosed_attributes = [];
        this.db.choosed_product_id = route.name;
        this.filter.emit();
      }
      else if(this.db.ismobile){
        this.db.choosed_product_id = route.name;
        this.filter.emit();
        // this.router.navigateByUrl('/pos/'+this.db.choosed_product_id)
      }
    }
    if(this.sub_cate_list.length > 0){
      let width = this.platform.width()
      if (width < 1025) 
        this.db.id_sub_category = true
       else 
        this.db.id_sub_category = false
      }
    else
      this.db.id_sub_category = false
    // this.pos.focusButton();
  }



  @HostListener('document:keyup', ['$event'])
  handleKeyboardEvent(event) {
    let key = event.key;
    let current_active = this.active;
    // if (this.pos.current_active == 'category') {
    //   if (key == 'ArrowDown') {
    //     if ((current_active + 1) < this.db.category.length) {
    //       this.active = current_active + 1;
    //       let check = document.getElementById(this.active + '_scroll') as HTMLInputElement
    //       check.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
    //       this.goto(this.db.category[this.active], 'child-1', this.active);
    //     }
    //   } else if (key == 'ArrowUp') {
    //     if ((current_active - 1) < this.db.category.length && (current_active - 1) != -1) {
    //       this.active = current_active - 1;
    //       let check1 = document.getElementById(this.active + '_scroll') as HTMLInputElement
    //       check1.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
    //       this.goto(this.db.category[this.active], 'child-1', this.active);
    //     }
    //   }
    // }
  }
}
